/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const wishlist = {
  wishlist: {
    empty: 'Ainda não existem produtos na sua lista de desejos',
    itemRemoved: 'O item selecionado foi excluído.',
    caption: 'Conteúdo da lista de desejos.',
  },
};
